import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { actionCreators } from "../redux/onDemandRevenueSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const CustomDateRanges = () => {
  const dispatch = useDispatch();

  const rangeOptions = useSelector((state) => state.onDemandRevenue.rangeOptions);
  const selectedRangeOption = useSelector((state) => state.onDemandRevenue.selectedRangeOption);

  const onSelectChange = (data) => {
    dispatch(actionCreators.updateCustomRange(data));
  };

  return (
    <MultiSelectDropdown
      options={rangeOptions}
      selectedFilters={selectedRangeOption}
      includeFilter={false}
      onSelectChange={onSelectChange}
    />
  );
};

export default CustomDateRanges;
